import styled, { css } from "styled-components";

export const BgHeader = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
  height: 25vh;
`;
export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

export const Title = styled.h1`
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 180%;
  text-align: center;
  margin: 0px 0px 5px;
`;

export const Notic = styled.p`
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
`;

export const Container = styled.div`
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  margin-top: -15px;
  padding: 20px 24px;
  margin-bottom: 20px;
  @media (max-width: 327px) {
    padding: 20px 16px;
  }
`;

export const InformationTitle = styled.h1`
  color: #4495b2;
  font-size: 20px;
  font-weight: 700;
  @media (max-width: 327px) {
    text-align: center;
  }
`;

export const FormWrapper = styled.div``;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0px;
`;
export const Lable = styled.label`
  color: #2a3e64;
  font-size: 14px;
  font-weight: 600;
`;

export const Requierd = styled.span``;
export const VerfiyContainer = styled.div``;

export const BtnConfirmation = styled.button`
  border-radius: 5px;
  background: #eaf9f8;
  color: #4495b2;
  border: none;
  padding: 12px 9px;
  width: 18%;
  margin-inline-start: 4px;
  text-align: center;
  position: relative;
  overflow: hidden;
  ${({ active }) =>
    active
      ? css`
          span:nth-child(1) {
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 3px;
            background: linear-gradient(to right, #60a1ce, #3bff3b);
            animation: animate1 2s linear infinite;
          }

          @keyframes animate1 {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
          span:nth-child(2) {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 3px;
            background: linear-gradient(to bottom, #60a1ce, #3bff3b);
            animation: animate2 2s linear infinite;
            animation-delay: 1s;
          }
          @keyframes animate2 {
            0% {
              transform: translateY(-100%);
            }
            100% {
              transform: translateY(100%);
            }
          }
          span:nth-child(3) {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 3px;
            background: linear-gradient(to left, #60a1ce, #3bff3b);
            animation: animate3 2s linear infinite;
          }

          @keyframes animate3 {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
          span:nth-child(4) {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 3px;
            background: linear-gradient(to top, #60a1ce, #3bff3b);
            animation: animate4 2s linear infinite;
            animation-delay: 1s;
          }

          @keyframes animate4 {
            0% {
              transform: translateY(100%);
            }
            100% {
              transform: translateY(-100%);
            }
          }
        `
      : ""};
`;
export const InputField = styled.input`
  margin: 2px 0px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #dde5ed;
`;
export const ErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`;
